export default "__VITE_ASSET__59e0ec8d__"